import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import Image from 'next/image';

import getMetaTagData from '../../../src/common/services/getMetaTagData';
// import adGenerater from '../../../src/common/services/adGenerater';
import TvTopMenu from '../../../src/component/pc/tv/TopMenu';
import Box from '../../../src/component/pc/common/Box';

import SliderWithTitle from '../../../src/component/pc/carousel/SliderWithTitle';

function Home({ testData, metaTagData }) {
  const router = useRouter();

  const [isOpen, setOpen] = useState(false);

  const sampleProps = {
    type: 'poster',
    img: 'http://img2.sbs.co.kr/img/sbs_cms/CH/2020/05/18/CH97142243_w666_h968.jpg',
    info: {
      title: '두줄노출두줄노출두줄노출두줄노출두줄노출두줄노출두줄노출두줄노출',
    },
    label: [{ type: 'free' }, { type: '19' }],
  };
  const samplePropList = [
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
    sampleProps,
  ];

  useEffect(() => {
    if (!isOpen) {
      // adGenerater('testAdId');
      setOpen(true);
    }
  }, [isOpen]);

  return (
    // TODO: `contents` css class를 빼는것이 맞는지 확인 필요
    <div className="contents">
      {/* <div id='container'> */}
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>
      <div role="main" id="container" className="tv_listcontents_wrap">
        {/* 페이지 명 클래스  */}
        <TvTopMenu
          sectionCode={router.query.pageSection}
          categoryCode={router.query.pageCategory}
        />

        {/* 기본 정렬 */}
        <div className="contents_area_tvlist">
          <div className="tv_list_w">
            <ul className="tv_list_inner">
              {samplePropList.map((item, index) => {
                return (
                  <li key={index} className="tv_list_cont">
                    <Box view {...item} />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* 슬라이드 정렬 */}
        {/* <SliderWithTitle
          title='큐레이션1' desc='' link=''
          data={samplePropList} type='theme' wrapperClass='contents_area_theme'
        /> */}
      </div>
    </div>
  );
}

export async function getServerSideProps(ctx) {
  const res = await fetch(process.env.API_TEST);
  const { home: testData } =
    res.status === 200 ? await res.json() : { home: {} };

  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { testData, metaTagData } };
}

export default Home;
